import { _ as _defineProperty } from '../../unsorted/defineProperty.js';
import { _ as _objectWithoutProperties } from '../../unsorted/objectWithoutProperties.js';
import { useMemo } from 'react';
import { m as merge } from '../../unsorted/index.js';
import { prettyFormatNumber } from '../../utils/numberHelpers.js';
import { jsx, jsxs, Fragment } from '@emotion/react/jsx-runtime';
import '@emotion/react';
import { B as Body } from '../Body/Body.js';
import { A as AspectRatioImage } from '../AspectRatioImage/AspectRatioImage.js';
import { useGetSubcomponentChild } from '../../hooks/useGetSubcompnentChild.js';
import { I as Icon } from '../Icon/Icon.js';
import { S as SmartClone } from '../SmartClone/SmartClone.js';
import { B as Box } from '../Box/Box.js';
import { cloneElementWithCssProp } from '../../utils/componentHelpers.js';

var _excluded$2 = ["sx", "children", "testId", "size", "weight", "className"];
function ownKeys$2(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$2(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function PriceDisplayCaption(_ref) {
  var _ref$sx = _ref.sx,
    sx = _ref$sx === void 0 ? {} : _ref$sx,
    children = _ref.children,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? "PriceDisplayCaption" : _ref$testId,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "xSmall" : _ref$size,
    _ref$weight = _ref.weight,
    weight = _ref$weight === void 0 ? "regular" : _ref$weight,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded$2);
  var prettyContent = children ? prettyFormatNumber(children) : null;
  var mergedSx = useMemo(function () {
    return merge({
      c: "base.color.text.body.secondary",
      textAlign: "left"
    }, sx);
  }, [sx]);
  return jsx(Body, _objectSpread$2(_objectSpread$2({}, props), {}, {
    sx: mergedSx,
    size: size,
    weight: weight,
    testId: testId,
    className: "".concat(className !== null && className !== void 0 ? className : "", " PriceDisplayCaption"),
    children: prettyContent
  }));
}
PriceDisplayCaption.displayName = "PriceDisplay.Caption";

var baseOuterContainerSx = {
  display: "inline-flex",
  flexDirection: "column",
  alignItems: "flex-end",
  textAlign: "right",
  wordBreak: "break-word",
  position: "relative",
  c: "base.color.text.body.primary"
};
var CURRENCY_IMAGE_SIZE = "0.84em";
var baseImageSx = {
  width: CURRENCY_IMAGE_SIZE,
  minw: "unset",
  mt: "-0.08em"
};
var priceContentSx = {
  d: "flex",
  alignItems: "center",
  gap: "0.3em",
  color: "inherit"
};

var _excluded$1 = ["className", "use"];
function ownKeys$1(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function PriceDisplayCurrencyImage(_ref) {
  var className = _ref.className,
    use = _ref.use,
    props = _objectWithoutProperties(_ref, _excluded$1);
  return jsx(AspectRatioImage, _objectSpread$1(_objectSpread$1({}, props), {}, {
    use: use,
    className: "".concat(className !== null && className !== void 0 ? className : "", " PriceDisplayCurrencyImage"),
    relativeImageSizeInLayout: CURRENCY_IMAGE_SIZE
  }));
}

var _excluded = ["price", "domRef", "sx", "testId", "rc", "className", "children", "fiatAmount"],
  _excluded2 = ["use"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function PriceDisplay(_ref) {
  var _ref5, _pickedPriceImagery$p, _pickedPriceImagery$p2;
  var price = _ref.price,
    domRef = _ref.domRef,
    _ref$sx = _ref.sx,
    sx = _ref$sx === void 0 ? {} : _ref$sx,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? "PriceDisplay" : _ref$testId,
    _ref$rc = _ref.rc,
    rc = _ref$rc === void 0 ? jsx("span", {}) : _ref$rc,
    className = _ref.className,
    children = _ref.children,
    fiatAmount = _ref.fiatAmount,
    props = _objectWithoutProperties(_ref, _excluded);
  var _ref2 = "use" in props ? props : _objectSpread(_objectSpread({}, props), {}, {
      use: undefined
    }),
    use = _ref2.use,
    boxDomAttrProps = _objectWithoutProperties(_ref2, _excluded2);
  var _ref3 = "size" in props ? props : {
      size: undefined
    },
    size = _ref3.size;
  var _ref4 = "weight" in props ? props : {
      weight: "bold"
    },
    weight = _ref4.weight;
  var prettyPrice = prettyFormatNumber(price);
  var currencyImage = useGetSubcomponentChild(children, PriceDisplayCurrencyImage);
  var caption = useGetSubcomponentChild(children, PriceDisplayCaption);
  var icon = useGetSubcomponentChild(children, Icon);
  var pickedPriceImagery = (_ref5 = currencyImage !== null && currencyImage !== void 0 ? currencyImage : icon) !== null && _ref5 !== void 0 ? _ref5 : null;
  var pickedPriceImagerySx = (_pickedPriceImagery$p = pickedPriceImagery === null || pickedPriceImagery === void 0 || (_pickedPriceImagery$p2 = pickedPriceImagery.props) === null || _pickedPriceImagery$p2 === void 0 ? void 0 : _pickedPriceImagery$p2.sx) !== null && _pickedPriceImagery$p !== void 0 ? _pickedPriceImagery$p : {};
  var mergedCurrencyImageSx = useMemo(function () {
    var _ref6, _sx$color;
    return merge(baseImageSx, {
      fill: (_ref6 = (_sx$color = sx.color) !== null && _sx$color !== void 0 ? _sx$color : sx.c) !== null && _ref6 !== void 0 ? _ref6 : "base.color.text.body.primary"
    }, pickedPriceImagerySx);
  }, [pickedPriceImagerySx, sx]);
  var priceContent = useMemo(function () {
    var _currencyImage$props$, _currencyImage$props;
    return cloneElementWithCssProp(use || jsx(Body, {
      size: size,
      weight: weight
    }), _objectSpread(_objectSpread({
      testId: "".concat(testId, "__price")
    }, size ? {
      size: size
    } : {}), {}, {
      sx: priceContentSx,
      children: jsxs(Fragment, {
        children: [prettyPrice, currencyImage ? jsx(SmartClone, {
          testId: "".concat(testId, "__price__currencyImage"),
          sx: mergedCurrencyImageSx,
          aspectRatio: (_currencyImage$props$ = (_currencyImage$props = currencyImage.props) === null || _currencyImage$props === void 0 ? void 0 : _currencyImage$props.aspectRatio) !== null && _currencyImage$props$ !== void 0 ? _currencyImage$props$ : "1",
          children: currencyImage
        }) : icon ? jsx(SmartClone, {
          testId: "".concat(testId, "__price__icon"),
          sx: mergedCurrencyImageSx,
          children: icon
        }) : null]
      }),
      className: "priceContent"
    }));
  }, [currencyImage, mergedCurrencyImageSx, icon, prettyPrice, size, testId, use, weight]);
  var fiatAmountCaption = useMemo(function () {
    if (!caption && !fiatAmount) return null;
    return fiatAmount ? jsx(PriceDisplayCaption, {
      size: "xSmall",
      weight: "regular",
      testId: "".concat(testId, "__fiatAmount"),
      children: fiatAmount
    }) : caption;
  }, [caption, testId, fiatAmount]);
  return jsxs(Box, _objectSpread(_objectSpread({}, boxDomAttrProps), {}, {
    rc: rc,
    testId: testId
    // @TODO: this should be a Span element, not HTMLDivElement
    ,
    domRef: domRef,
    sx: merge(baseOuterContainerSx, sx),
    className: "".concat(className !== null && className !== void 0 ? className : "", " PriceDisplay"),
    children: [priceContent, fiatAmountCaption]
  }));
}
PriceDisplay.displayName = "PriceDisplay";
PriceDisplay.CurrencyImage = PriceDisplayCurrencyImage;
PriceDisplay.Caption = PriceDisplayCaption;
PriceDisplay.Icon = Icon;

export { PriceDisplay as P };
//# sourceMappingURL=PriceDisplay.js.map
